import type { NoteColors, NoteFigure } from './types';

/** Colores tipo boomwhackers / campanas diatónicas */
export const DEFAULT_NOTE_COLORS: NoteColors = {
  do: '#E53935',
  re: '#FB8C00',
  mi: '#FDD835',
  fa: '#43A047',
  sol: '#29B6F6',
  la: '#7E57C2',
  si: '#EC407A',
  rest: '#B0BEC5',
};

/** Círculos del selector de figuras rítmicas. */
export const FIGURE_PICKER_COLORS: Record<NoteFigure, string> = {
  redonda: '#E53935',
  blanca: '#FB8C00',
  negra: '#43A047',
  corchea: '#29B6F6',
  semicorchea: '#7E57C2',
};

export const WELCOME_MESSAGE = '¡Bienvenidos a Boom Patrones!';
export const WELCOME_SUBTITLE =
  'Arma patrones con colores y figuras musicales, luego escúchalos';
